import React, {Component} from 'react'
import {Link} from 'react-router-dom'
import {Dl, Dd, Dt} from 'components/SecondaryPanel'
import {Panel, Headding, Item} from 'components/PrimaryPanel'
import {recordDisplay} from 'utils'
import {connect} from 'react-redux'
import {isEmpty, isObject, isString, isUndefined, map} from 'lodash'
import api from 'api'
import {actionCreators} from 'actions'
import moment from 'moment'
import withRouterLegacy from 'withRouterLegacy'

const change = (value) => {
  if (isString(value)) {
    return value
  }
  if (isObject(value) && !isUndefined(value.filename)) {
    return value.filename || 'null'
  }
  return JSON.stringify(value)
}

export const Log = ({log}) => (
  <div>
    <Panel>
      <Headding>更新情報</Headding>
      <Item>
        <Dl>
          <Dt>アカウント</Dt>
          <Dd>{recordDisplay(log.acted_user_email)}</Dd>
          <Dt>ip</Dt>
          <Dd>{recordDisplay(log.ip)}</Dd>
          <Dt>操作種別</Dt>
          <Dd>{recordDisplay(log.operation_label)}</Dd>
          <Dt>操作対象</Dt>
          <Dd>{recordDisplay(log.employee_full_name)}</Dd>
          <Dt>日時</Dt>
          <Dd>{recordDisplay(log.created_at && moment(log.created_at).format('LL LTS'))}</Dd>
        </Dl>
      </Item>
    </Panel>
    {!isEmpty(log.changes) && [
      <h3 className="m-title-small" key="title">
        更新内容
      </h3>,
      <div className="l-overflow-scroll" key="changes">
        <table className="m-table-list">
          <thead>
            <tr>
              <th>項目</th>
              <th>変更前</th>
              <th>変更後</th>
            </tr>
          </thead>
          <tbody>
            {map(log.changes, ({label, history: [before, after]}) => (
              <tr key={label}>
                <td style={{wordBreak: 'break-all'}}>{label}</td>
                <td style={{wordBreak: 'break-all'}}>{change(before)}</td>
                <td style={{wordBreak: 'break-all'}}>{change(after)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>,
    ]}
  </div>
)

class Show extends Component {
  componentDidMount() {
    const {
      token,
      match: {
        params: {id},
      },
      loadData,
    } = this.props
    loadData(token, id)
  }

  componentWillUnmount() {
    this.props.destroy()
  }

  render() {
    const {log} = this.props
    return (
      <div>
        <div className="l-main-title-wrap">
          <h1 className="m-title-main">操作履歴</h1>
        </div>
        <div className="l-wrap-s l-contents-wrap">
          <div className="l-breadcrumb u-mb20">
            <Link to="/settings" className="l-breadcrumb-link">
              設定
            </Link>
            <Link to="/settings/audit_logs" className="l-breadcrumb-link">
              操作履歴
            </Link>
            <span className="l-breadcrumb-here">操作履歴詳細</span>
          </div>
          <Log log={log} />
        </div>
      </div>
    )
  }
}

export default connect(
  (state) => ({
    log: state.settings.auditLogs.current.data,
    token: state.auth.token,
  }),
  (dispatch) => ({
    loadData(token, id) {
      dispatch(actionCreators.settings.auditLogs.current.fetchData(api.createWithAuth(token).auditLogs.get(id)))
    },
    destroy() {
      dispatch(actionCreators.settings.auditLogs.current.destroy())
    },
  })
)(withRouterLegacy(Show))
